import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row, CardHeader, Button } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { CitySale } from './city-sale';

const RowCustom = ({ provider, row, index }) => {
  const [open, setOpen] = useState(false);

  const updateStateOpen = (e) => {
    e.preventDefault();
    setOpen(!open);
  };
  return !open ? (
    <tr
      key={index}
      {...row.getRowProps()}
      {...provider.draggableProps}
      ref={provider.innerRef}
      onClick={updateStateOpen}
    >
      <td {...provider.dragHandleProps}> = </td>
      {row.cells.map((cell) => {
        return (
          <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
            {cell.render('Cell')}
          </td>
        );
      })}
    </tr>
  ) : (
    <>
      <tr
        key={index}
        {...row.getRowProps()}
        {...provider.draggableProps}
        ref={provider.innerRef}
        onClick={updateStateOpen}
      >
        <td {...provider.dragHandleProps}> = </td>
        {row.cells.map((cell) => {
          return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
        })}
      </tr>
      <tr>
        <td colSpan='100%'>
          <>
            <CitySale data={row.original.cities} route={row.original} />
          </>
        </td>
      </tr>
    </>
  );
};

export function TableGenericWithDragAndDrop({ columns, data, setData }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;

  const handleUpdatePosition = (dataView) => {
    handleSendGeneric(
      '/v1/data-view?type=ROUTE&action=UPDATE',
      'POST',
      dataView
    );
  };

  const handleDragEnd = async (e) => {
    const { source, destination } = e;
    if (!destination || source.index === destination.index) return;
    let dataRaw = [];

    setData((prevData) => {
      const tempData = [...prevData];
      const [removed] = tempData.splice(source.index, 1);
      tempData.splice(destination.index, 0, removed);
      dataRaw = [...tempData];
      return tempData;
    });

    await handleUpdatePosition(dataRaw);
  };

  const handleSavePosition = () => {
    handleSendGeneric('/v1/data-view?type=ROUTE', 'POST', data).then(
      (response) => {
        setData((prevData) => {
          return response.data[0];
        });
      }
    );
  };

  return (
    <>
      <CardHeader className='border-0'>
        <Row className='align-items-center'>
          <div
            style={{ display: 'flex', justifyContent: 'space-between' }}
            className='col'
          >
            <h3 className='lg' style={{ fontSize: '18px' }}>
              Rotas
            </h3>
            <Button
              color='success'
              onClick={() => handleSavePosition()}
              size='lg'
            >
              Ordernar
            </Button>
          </div>
        </Row>
      </CardHeader>
      <GlobalFilter
        disableButtomCreate={true}
        filter={globalFilter}
        setFilter={setGlobalFilter}
        urlNewItem={'/route/new'}
      />
      <DragDropContext onDragEnd={handleDragEnd}>
        <Table responsive striped hover {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                <th />
                {headerGroup.headers.map((column) => (
                  <th
                    scope='col'
                    {...column.getHeaderProps()}
                    style={{ fontSize: '18px' }}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <Droppable droppableId='droppable-1'>
            {(provider) => (
              <tbody
                {...getTableBodyProps()}
                ref={provider.innerRef}
                {...provider.droppableProps}
              >
                {rows.length !== 0 ? (
                  rows.map((row, index) => {
                    prepareRow(row);
                    return (
                      <Draggable
                        key={row?.original?.name}
                        draggableId={row?.original?.name}
                        index={index}
                      >
                        {(provider) => (
                          <RowCustom
                            provider={provider}
                            row={row}
                            index={index}
                          />
                        )}
                      </Draggable>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan='7'
                      style={{
                        textAlign: 'center',
                        width: '20px',
                        fontSize: '18px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '14px',
                          alignItems: 'center',
                        }}
                      >
                        Não há registros disponíveis, por gentileza cadastre uma
                        rota!
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>
    </>
  );
}

export const SaleScreen = () => {
  const [route, setRoute] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function getData() {
      try {
        const responseRoute = await handleSendGeneric('/v1/route', 'GET');
        if (!responseRoute) {
          setError(true);
          return;
        }
        const response = await handleSendGeneric(
          '/v1/data-view?type=ROUTE',
          'POST',
          responseRoute
        );
        if (response?.data?.[0]) {
          setRoute(response.data[0]);
        }
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    }
    async function getProduct() {
      handleSendGeneric('/v1/product', 'GET');
      handleSendGeneric('/v1/information', 'GET');
    }
    getData();
    getProduct();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return <div>{actionId}</div>;
        },
      },
    ],
    []
  );

  if (loading) {
    return (
      <>
        <Header />
        <Container className='mt--7' fluid>
          <Row>
            <div className='col' style={{ textAlign: 'center', paddingTop: '60px', color: '#fff' }}>
              Carregando rotas...
            </div>
          </Row>
        </Container>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <Container className='mt--7' fluid>
          <Row>
            <div className='col' style={{ textAlign: 'center', paddingTop: '60px', color: '#f5365c', fontWeight: 'bold', fontSize: '18px' }}>
              Não foi possível carregar os dados. Tente novamente mais tarde.
            </div>
          </Row>
        </Container>
      </>
    );
  }

  return (
    <>
      <Header />

      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <div
              style={{
                textAlign: 'center',
                color: 'yellow',
                marginBottom: '12px',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
            >
              Dica: Caso inclua uma nova rota ou uma nova cidade na rota ou um
              novo cliente na cidade faça a ordenação que será atualizado a
              ordenação dos dados!
            </div>
            <Card className='shadow'>
              <TableGenericWithDragAndDrop
                columns={columns}
                data={route}
                setData={setRoute}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
